// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__zochu","colCheckbox":"styles_colCheckbox__2B9OG"};